import PropTypes from "prop-types";
import logo from "../../assets/logo/zeropa-on-transparent.png";
import dark from "../../assets/logo/zeropa-dark.png";

/**
 * @typedef LogoProps
 * @property {boolean} isDark - Whether to use the dark logo or not
 * @returns the Logo component
 */

/**
 * Logo component
 * @param {LogoProps} props - The props for the component
 */
const Logo = ({ isDark = false }) => {
  if (isDark) {
    return (
      <img
        src={dark}
        alt="The ZeroPA logo"
        title="ZeroPA - Interest free loans"
        className="zeropa-logo"
        style={{ margin: "0 auto" }}
      />
    );
  }

  return (
    <img
      src={logo}
      alt="The ZeroPA logo"
      title="ZeroPA - Interest free loans"
      className="zeropa-logo"
      style={{ margin: "0 auto" }}
    />
  );
};

Logo.propTypes = {
  isDark: PropTypes.bool,
};

export default Logo;
